(function () {
  function initInlineVideo(section) {
    const track = section.querySelector("[data-cc-track]");
    if (track) {
      track.scrollTo({ left: 0, behavior: "auto" });
      requestAnimationFrame(() => track.scrollTo({ left: 0, behavior: "auto" }));
    }

    const videos = Array.from(section.querySelectorAll("[data-vc-video]"));
    if (!videos.length) return;

    let currentPlaying = null;

    function setControls(videoEl, show) {
      videoEl.controls = show;
    }

    videos.forEach((vid) => {
      vid.muted = true;
      vid.playsInline = true;
      vid.pause();
      vid.controls = false;
      vid.dataset.vcIdx = Array.prototype.indexOf.call(videos, vid);

      vid.addEventListener("play", () => {
        if (currentPlaying && currentPlaying !== vid) currentPlaying.pause();
        currentPlaying = vid;
      });

      vid.addEventListener("pause", () => {
        if (currentPlaying === vid) {
          setControls(vid, false);
        }
      });

      vid.addEventListener("mouseenter", () => setControls(vid, true));
      vid.addEventListener("mouseleave", () => {
        if (vid.paused) setControls(vid, false);
      });
    });

    const observer = new IntersectionObserver(
      (entries) => {
        const visible = entries
          .filter((entry) => entry.isIntersecting && entry.intersectionRatio >= 0.35)
          .map((entry) => entry.target)
          .sort((a, b) => (parseInt(a.dataset.vcIdx || "0", 10) - parseInt(b.dataset.vcIdx || "0", 10)));

        // If nothing is strongly visible, keep current playing to avoid flicker during swipe
        const nextPlay = visible.length ? visible[0] : currentPlaying;

        videos.forEach((vid) => {
          if (vid === nextPlay) {
            if (currentPlaying && currentPlaying !== vid) currentPlaying.pause();
            currentPlaying = vid;
            vid.play().catch(() => {});
            setControls(vid, true);
          } else if (!visible.length || vid !== currentPlaying) {
            // Only pause others when nothing is strongly visible or they aren't the current
            vid.pause();
            setControls(vid, false);
          }
        });
      },
      { threshold: [0.2, 0.35, 0.6, 0.9] }
    );

    videos.forEach((vid) => observer.observe(vid));

    const firstInTrack = videos[0];
    if (firstInTrack) {
      videos.forEach((v, idx) => {
        if (idx !== 0) v.pause();
      });
      firstInTrack.play().catch(() => {});
      currentPlaying = firstInTrack;
    }

    videos.forEach((vid, idx) => {
      vid.addEventListener("ended", () => {
        const next = videos[idx + 1];
        if (next) {
          if (currentPlaying && currentPlaying !== next) currentPlaying.pause();
          currentPlaying = next;
          next.play().catch(() => {});
          setControls(next, true);
        } else {
          setControls(vid, false);
          vid.pause();
        }
      });
    });
  }

  function boot() {
    document.querySelectorAll(".vc-wrap").forEach(initInlineVideo);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  document.addEventListener("shopify:section:load", (event) => {
    const section = event.target?.querySelector?.(".vc-wrap") || event.target;
    if (section && section.classList.contains("vc-wrap")) {
      initInlineVideo(section);
    }
  });
})();
